import { render, staticRenderFns } from "./RankAndReward.vue?vue&type=template&id=438da27c&scoped=true&"
import script from "./RankAndReward.vue?vue&type=script&lang=js&"
export * from "./RankAndReward.vue?vue&type=script&lang=js&"
import style0 from "./RankAndReward.vue?vue&type=style&index=0&id=438da27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438da27c",
  null
  
)

export default component.exports